export default {"src":"/_next/static/media/check-circle.0844d6cd.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};